import { getBoggleBadgePointsForLevel, type BoggleBadgeDefinition } from '../types'

export const corneredBadgeDefinition: BoggleBadgeDefinition = {
  category: 'path',
  description: 'Play a word using each corner tile',
  iconId: 'cornered',
  id: 'cornered',
  level: 'rare',
  lockedReveal: 'reveal',
  name: 'Cornered',
  points: getBoggleBadgePointsForLevel('rare'),
}
